import { Component, OnDestroy, OnInit } from "@angular/core";
import { first } from "rxjs/operators";

import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { ChatService } from "../../../chat.service";

@Component({
  selector: "app-chat-sidebar",
  templateUrl: "./chat-sidebar.component.html",
  styleUrls: ["./chat-sidebar.component.scss"],
})
export class ChatSidebarComponent implements OnInit, OnDestroy {
  // Public
  public contacts;
  public chatUsers;
  public searchText;
  public chats;
  public selectedHash: string = null;
  public userProfile;

  constructor(
    private _chatService: ChatService,
    private _coreSidebarService: CoreSidebarService,
  ) {}

  ngOnInit() {
    // Subscribe to contacts
    this._chatService.onContactsChange.subscribe((res) => {
      this.contacts = res;
    });

    // Subscribe to chat users
    this._chatService.onChatUsersChange.subscribe((res) => {
      this.chatUsers = res;
    });

    // Subscribe to selected Chats
    this._chatService.onSelectedChatChange.subscribe((res) => {
      this.chats = res;
    });

    // Add Unseen Message To Chat User
    this._chatService.onChatsChange.pipe(first()).subscribe((chats) => {
      chats.map((chat) => {
        this.chatUsers.map((user) => {
          if (user.hash === chat.hash) {
            user.unread_messages = chat.unread_messages;
          }
        });
      });
    });

    // Subscribe to User Profile
    this._chatService.onUserProfileChange.subscribe((response) => {
      this.userProfile = response;
    });
  }

  openChat(hash: string) {
    this._chatService.openChat(hash);

    // Reset unread Message to zero
    this.chatUsers.map((user: any) => {
      this._chatService.subTractNotificationNumber(this._chatService.chatNotification - user.unread_messages);
      if (user.hash === hash) {
        user.unread_messages = 0;
      }
    });
  }

  toggleSidebar(name: string) {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  setSelectedChat(hash: string, isContact: boolean = false) {
    if (isContact) {
      //In caso sia un contatto resetto selectedChat perchè stiamo selezionando un contatto e non una chat
      this._chatService.selectedChat = null;
    }
    this.selectedHash = hash;
  }

  ngOnDestroy() {
    this._chatService.selectedChat = null;
  }
}
